import { useId } from "react";

export function useIdOr(id: string | undefined) {
  const localId = useId();

  return id ?? localId;
}
